import { render, staticRenderFns } from "./fechamento_mensal.vue?vue&type=template&id=33938bb6&"
import script from "./fechamento_mensal.vue?vue&type=script&lang=js&"
export * from "./fechamento_mensal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports